import React from 'react';
import './App.css';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';

const Article = () => {
  return (
    <div className="page-fade-in">
      {/* Back Button */}
      <div className="container" style={{paddingTop: '2rem'}}>
        <Link to="/insights" style={{display: 'flex', alignItems: 'center', color: '#00a40e', fontWeight: '700'}}>
          <FaArrowLeft style={{marginRight: '8px'}}/> Back to Insights
        </Link>
      </div>

      {/* Article Header */}
      <div className="container" style={{paddingTop: '4rem', maxWidth: '800px', margin: '0 auto'}}>
        <span className="section-label">Artificial Intelligence</span>
        <h1 style={{fontSize: '3.5rem', fontWeight: '800', marginBottom: '2rem', lineHeight: '1.1'}}>
          The Generative AI Advantage in Financial Services
        </h1>
        <div style={{display: 'flex', alignItems: 'center', color: '#666', marginBottom: '3rem'}}>
          <span>October 12, 2025</span>
          <span style={{margin: '0 10px'}}>•</span>
          <span>5 Min Read</span>
        </div>
      </div>

      {/* Huge Main Image */}
      <div style={{height: '60vh', width: '100%', overflow: 'hidden'}}>
        <img 
          src="https://images.unsplash.com/photo-1620712943543-bcc4688e7485?auto=format&fit=crop&w=1200&q=80" 
          alt="Article Cover" 
          style={{width: '100%', height: '100%', objectFit: 'cover'}}
        />
      </div>

      {/* Article Body */}
      <div className="container" style={{maxWidth: '800px', margin: '0 auto', padding: '4rem 0'}}>
        <p style={{fontSize: '1.25rem', lineHeight: '1.8', color: '#ccc', marginBottom: '2rem'}}>
          Financial institutions are standing at a precipice. The adoption of Generative AI is no longer a "nice to have"—it is becoming the primary differentiator between market leaders and legacy players.
        </p>
        <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: '#a1a1a1', marginBottom: '2rem'}}>
          In this report, we explore how Large Language Models (LLMs) are reshaping risk assessment, customer service, and fraud detection. The data suggests that early adopters are seeing a 40% reduction in operational costs within the first 12 months.
        </p>
        <h2 style={{fontSize: '2rem', marginTop: '3rem', marginBottom: '1.5rem'}}>The Strategic Imperative</h2>
        <p style={{fontSize: '1.1rem', lineHeight: '1.8', color: '#a1a1a1', marginBottom: '2rem'}}>
          Implementing AI requires more than just technology, it requires a fundamental shift in organizational culture and data governance. Exia Group recommends a three-phased approach to implementation...
        </p>
      </div>
    </div>
  );
};

export default Article;